import { EntityAdapter } from 'vue-entity-adapter'

export const adapter = new EntityAdapter((a, b) => b.created_at.localeCompare(a.created_at))

export default adapter
